import { render, staticRenderFns } from "./SysParam.vue?vue&type=template&id=59cfbe9a&scoped=true&"
import script from "./SysParam.vue?vue&type=script&lang=js&"
export * from "./SysParam.vue?vue&type=script&lang=js&"
import style0 from "./SysParam.vue?vue&type=style&index=0&id=59cfbe9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cfbe9a",
  null
  
)

export default component.exports